export const formatNumber = (value?: number | string) => {
  if (value === undefined) return '-';

  const num = Number(value);
  return new Intl.NumberFormat('en-US').format(num).replace(/\u202F/g, ' ');
};

export function roundToNext100(value: number) {
  return Math.ceil(value / 100) * 100;
}

export function roundToPrev100(value: number) {
  return Math.floor(value / 100) * 100;
}
